'use client';

import Script from 'next/script';
import { PropsWithChildren } from 'react';

import { configPaymentsLib } from '../ExternalMainScripts/helpers';

export const ExternalScripts = ({ children }: PropsWithChildren) => (
  <>
    {children}
    <Script
      src="https://payments-lib.cdn.s7s.ai/v1/index.js"
      onLoad={configPaymentsLib}
    />
  </>
);
